/**
 * File: maApp.core.module.js
 *
 * Declare, define, and config the main app object
 *
 */
(function(){
    angular
        .module('maApp.core', [
            'ngRoute',
            'ngAnimate',
            'ngMessages',
            'LocalStorageModule',
            'ngDialog',
            'maApp.parse',
            'maApp.validation',
            'maApp.view',
            'maApp.remoteRequests',
            'maApp.error',
            'maApp.flow'
        ]);
})();